import React, { Component } from 'react';
import LoginForm from '../../components/LoginForm';
import styles from './style.css';

class LoginPage extends Component {
    render() {
        return (
            <div className={styles.page}>
                <LoginForm />
            </div>
        );
    }
}

export default LoginPage;


// WEBPACK FOOTER //
// ./src/containers/LoginPage/index.js